// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23NNZ","type":"styles_type__5uIWC","choices":"styles_choices__3nuf8"};